import React from 'react';
import { FavoriteAPISubscriber } from '@atlassian/jira-favourite-api-controller/src/components.tsx';
import { FavoriteChangeConsumer } from '../FavoriteChangeConsumer.tsx';
import ImperativeApi from './view.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function ImperativeApiWrapper(_props: Record<any, any>) {
	return (
		<FavoriteChangeConsumer>
			{(favoriteChangeContext) => (
				<FavoriteAPISubscriber>
					{(__, actions) => (
						<ImperativeApi
							items={favoriteChangeContext.items}
							changeFavorite={favoriteChangeContext.changeFavorite}
							// @ts-expect-error - TS2322 - Type 'BoundActions<State, Actions>' is not assignable to type 'Actions'.
							callbackRegistry={actions}
						/>
					)}
				</FavoriteAPISubscriber>
			)}
		</FavoriteChangeConsumer>
	);
}
